export default __webpack_public_path__ + "static/media/Kaggen_sur.dc02b6c4.jpg";